import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Printer, Copy, FilePlus } from "lucide-react";
import { fmtMoney } from "@/lib/api";
import { toast } from "sonner";

export function ReceiptDialog({ order, onClose, onNewOrder }) {
  if (!order) return null;

  const copyCode = async () => {
    try {
      await navigator.clipboard.writeText(order.code);
      toast.success("Đã copy mã đơn");
    } catch {
      toast.error("Không copy được. Mã: " + order.code);
    }
  };

  const print = () => {
    window.print();
  };

  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="rounded-sm max-w-md" data-testid="pos-receipt-dialog">
        <DialogHeader>
          <DialogTitle>✓ Đơn đã tạo</DialogTitle>
          <DialogDescription>Đơn hàng đã được lưu thành công.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between">
            <span className="text-stone-700">Mã đơn</span>
            <span className="font-mono font-bold" data-testid="receipt-code">{order.code}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-stone-700">Tổng tiền</span>
            <span className="font-mono font-bold text-emerald-800">{fmtMoney(order.total)}</span>
          </div>
        </div>
        <DialogFooter className="flex-row gap-2">
          <Button type="button" variant="outline" onClick={copyCode} className="rounded-sm flex-1">
            <Copy className="w-4 h-4 mr-1" aria-hidden="true" />Copy mã
          </Button>
          <Button type="button" variant="outline" onClick={print} className="rounded-sm flex-1">
            <Printer className="w-4 h-4 mr-1" aria-hidden="true" />In
          </Button>
          <Button type="button" onClick={onNewOrder} className="rounded-sm bg-emerald-800 hover:bg-emerald-900 flex-1">
            <FilePlus className="w-4 h-4 mr-1" aria-hidden="true" />Đơn mới
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
